import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';

import { TableComponent } from '../table/table.component';

@Component({
  selector: 'cp-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelComponent implements AfterContentInit {
  @Input()
  header: string;

  @Input()
  disableAutoTable = false;

  @ContentChild(TableComponent)
  tableContent?: TableComponent;

  table = false;

  ngAfterContentInit() {
    if (this.tableContent && !this.disableAutoTable) {
      this.table = true;
      this.tableContent.panel = true;
    }
  }
}
